import React, { useState, useEffect } from "react";
import { lang } from "../lang";

function TodoList({ list, dispatch }) {
  const [listName, setListName] = useState(list.name);
  const [newItem, setNewItem] = useState("");
  const [newTitle, setNewTitle] = useState("");
  const [newLastName, setNewLastName] = useState("");
  const [newFirstName, setNewFirstName] = useState("");

  useEffect(() => {
    setListName(list.name);
  }, [list.name]);

  const handleNameChange = (e) => {
    setListName(e.target.value);
  };

  const handleNameCommit = () => {
    if (listName !== list.name) {
      if (process.env.NODE_ENV === "development") {
        console.log(
          "Dispatching UPDATE_LIST for list name:",
          list.id,
          listName
        );
      }
      dispatch({
        type: "UPDATE_LIST",
        id: list.id,
        updates: { name: listName },
      });
    }
  };

  const handleAddItem = (e) => {
    if (e.key === "Enter" && newItem.trim()) {
      if (process.env.NODE_ENV === "development") {
        console.log("Dispatching UPDATE_LIST for new item:", list.id, newItem);
      }
      dispatch({
        type: "UPDATE_LIST",
        id: list.id,
        updates: {
          items: [
            ...(list.items || []),
            { id: Date.now().toString(), text: newItem, completed: false },
          ],
        },
      });
      setNewItem("");
    }
  };

  const handleAddBookItem = (e) => {
    if (
      e.key === "Enter" &&
      newTitle.trim() &&
      newLastName.trim() &&
      newFirstName.trim()
    ) {
      if (process.env.NODE_ENV === "development") {
        console.log("Dispatching UPDATE_LIST for new book item:", list.id, {
          title: newTitle,
          lastName: newLastName,
          firstName: newFirstName,
        });
      }
      dispatch({
        type: "UPDATE_LIST",
        id: list.id,
        updates: {
          items: [
            ...(list.items || []),
            {
              id: Date.now().toString(),
              title: newTitle,
              lastName: newLastName,
              firstName: newFirstName,
              completed: false,
            },
          ],
        },
      });
      setNewTitle("");
      setNewLastName("");
      setNewFirstName("");
    }
  };

  const handleToggleItem = (itemId) => {
    if (process.env.NODE_ENV === "development") {
      console.log("Dispatching UPDATE_LIST for toggle item:", list.id, itemId);
    }
    dispatch({
      type: "UPDATE_LIST",
      id: list.id,
      updates: {
        items: list.items.map((item) =>
          item.id === itemId ? { ...item, completed: !item.completed } : item
        ),
      },
    });
  };

  const handleDeleteList = () => {
    if (process.env.NODE_ENV === "development") {
      console.log("Dispatching DELETE_LIST:", list.id);
    }
    dispatch({ type: "DELETE_LIST", id: list.id });
  };

  return (
    <div className="todo-list">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <input
          type="text"
          value={listName}
          onChange={handleNameChange}
          onBlur={handleNameCommit}
        />
        <button className="delete" onClick={handleDeleteList}>
          <img src={require("../svg/delete.svg")} alt={lang.task.deleteAlt} />
        </button>
      </div>
      {(list.items || []).map((item) => (
        <div
          key={item.id}
          className={`todo-item ${item.completed ? "completed" : ""}`}
        >
          {list.type === "book" ? (
            <div className="book-item">
              <div className="book-title">{item.title}</div>
              <div className="book-author">
                {item.lastName}, {item.firstName}
              </div>
            </div>
          ) : (
            <>
              <input
                type="checkbox"
                checked={item.completed}
                onChange={() => handleToggleItem(item.id)}
              />
              <input
                type="text"
                value={item.text}
                onChange={(e) => {
                  if (process.env.NODE_ENV === "development") {
                    console.log(
                      "Dispatching UPDATE_LIST for item text:",
                      item.id,
                      e.target.value
                    );
                  }
                  dispatch({
                    type: "UPDATE_LIST",
                    id: list.id,
                    updates: {
                      items: list.items.map((i) =>
                        i.id === item.id ? { ...i, text: e.target.value } : i
                      ),
                    },
                  });
                }}
              />
            </>
          )}
        </div>
      ))}
      {list.type === "book" ? (
        <div className="book-inputs">
          <input
            type="text"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
            onKeyDown={handleAddBookItem}
            placeholder={lang.todoList.titlePlaceholder}
          />
          <input
            type="text"
            value={newLastName}
            onChange={(e) => setNewLastName(e.target.value)}
            onKeyDown={handleAddBookItem}
            placeholder={lang.todoList.lastNamePlaceholder}
          />
          <input
            type="text"
            value={newFirstName}
            onChange={(e) => setNewFirstName(e.target.value)}
            onKeyDown={handleAddBookItem}
            placeholder={lang.todoList.firstNamePlaceholder}
          />
        </div>
      ) : (
        <input
          type="text"
          value={newItem}
          onChange={(e) => setNewItem(e.target.value)}
          onKeyDown={handleAddItem}
          placeholder={lang.taskColumn.bulkTaskInputPlaceholder}
        />
      )}
    </div>
  );
}

export default TodoList;
